import classNames from 'classnames';

const tableHeaderStyle = 'font-medium pb-3 px-4 md:px-8';
const tableBodyStyle = 'py-3 border-b px-4 md:px-8';

export default function AccommodationTable({
  className = '',
  roomList = [],
  isPackage = false,
}) {
  if (roomList?.length === 0) {
    return null;
  }

  return (
    <table
      className={`${className} text-[16px] table-fixed w-full text-left break-words bg-white`}
    >
      <thead>
        <tr className="text-gray-500 border-b border-t">
          {isPackage && (
            <th className={`${tableHeaderStyle} w-[30%] pt-3`}>Room</th>
          )}
          <th
            className={classNames(
              `${tableHeaderStyle} pt-3`,
              { 'w-[70%] lg:w-[50%]': !isPackage },
              { grow: isPackage },
            )}
          >
            Room name
          </th>
          {!isPackage && (
            <th className={`${tableHeaderStyle} w-[30%] lg:w-[50%] pt-3 hidden`}>
              Room number
            </th>
          )}
        </tr>
      </thead>
      <tbody>
        {roomList.map(({ name, number }, index) => (
          <tr key={`${index + 1}`}>
            {isPackage && <td className={tableBodyStyle}>{index + 1} </td>}
            <td className={tableBodyStyle}>{name} </td>
            {!isPackage && <td className={tableBodyStyle}>{number}</td>}
          </tr>
        ))}
      </tbody>
    </table>
  );
}
